var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5283 14.5691C19.2149 14.8728 19.0709 15.312 19.1423 15.7427L20.2179 21.6953C20.3086 22.1998 20.0957 22.7104 19.6734 23.0019C19.2597 23.3044 18.7092 23.3407 18.2579 23.0987L12.8994 20.3039C12.7131 20.2047 12.5062 20.1515 12.2944 20.1454H11.9666C11.8528 20.1624 11.7415 20.1987 11.6399 20.2543L6.28018 23.0624C6.01522 23.1955 5.71517 23.2427 5.42118 23.1955C4.70493 23.06 4.22704 22.3776 4.34439 21.6578L5.42118 15.7052C5.49256 15.2709 5.34858 14.8293 5.03523 14.5208L0.66639 10.2862C0.30101 9.93172 0.173974 9.39938 0.340936 8.91906C0.503058 8.43995 0.916833 8.0903 1.41651 8.01166L7.42956 7.13934C7.88689 7.09216 8.28857 6.81389 8.49424 6.40253L11.1439 0.970218C11.2068 0.849231 11.2878 0.737923 11.3858 0.643553L11.4947 0.558862C11.5516 0.495949 11.6169 0.443925 11.6895 0.401579L11.8214 0.353185L12.0271 0.268494H12.5364C12.9913 0.315679 13.3918 0.587899 13.6011 0.994415L16.2858 6.40253C16.4794 6.79816 16.8556 7.0728 17.29 7.13934L23.303 8.01166C23.8112 8.08425 24.2359 8.43511 24.404 8.91906C24.5625 9.40422 24.4258 9.93656 24.0532 10.2862L19.5283 14.5691Z",
    fill: "#2F4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/Star-Icon.925720fda8a79a7d26f926bd30668222.svg";
export { ForwardRef as ReactComponent };